module.exports = __webpack_public_path__ + "img/share-14.ea961a32.jpg";